/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CursorPaginationDto } from '../../models/cursor-pagination-dto';
import { NoticeDto } from '../../models/notice-dto';

export interface NoticeControllerSearchCursorV1$Params {

/**
 * 페이지 크기
 */
  pageSize?: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 커서
 */
  cursor?: string;

/**
 * 고정 여부
 */
  isPinned?: boolean;

/**
 * 노출 여부
 */
  isExposed?: boolean;

/**
 * 공지사항 게시판 유형 필터
 */
  type?: 'MILLIONSHOW' | 'GOODSPACE' | 'ALLHOUSE' | 'STARTFAIR' | 'AGRITEX' | 'GIFTFAIR';
}

export function noticeControllerSearchCursorV1(http: HttpClient, rootUrl: string, params?: NoticeControllerSearchCursorV1$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto & {
'items'?: Array<NoticeDto>;
}>> {
  const rb = new RequestBuilder(rootUrl, noticeControllerSearchCursorV1.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('cursor', params.cursor, {});
    rb.query('isPinned', params.isPinned, {});
    rb.query('isExposed', params.isExposed, {});
    rb.query('type', params.type, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CursorPaginationDto & {
      'items'?: Array<NoticeDto>;
      }>;
    })
  );
}

noticeControllerSearchCursorV1.PATH = '/api/v1/notice/search/cursor';
